const routes = [
  {
    index: true,
    label: 'Abdullah Hasani',
    path: '/',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'Certificates',
    path: '/certificates',
  },
  {
    label: 'Now',
    path: '/now',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
